import React, { Component } from 'react';
import { Modal, Button, Table, message, Tabs } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ExportUtil from '../../../common/ExportUtil';

const TabPane = Tabs.TabPane;
const clinicalQuotationTypeShow = {
    'CLINICAL_QUOTATION_TYPE_VISIT': '访视报价',
    'CLINICAL_QUOTATION_TYPE_FTE': 'FTE报价',
    'CLINICAL_QUOTATION_TYPE_TASK': 'TASK报价',
    'CLINICAL_QUOTATION_TYPE_BALL_PARK': 'Ballpark报价',
}

class QuoteVersionRecord extends Component {
    state = {
        tabs: [],
        activeKey: '',
        data: {},
        record: {},
        visible: false,
        loading: false,
    }

    show = (record = {}) => { 
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: {},
            tabs: [],
            record: {},
            visible: false,
        });
    }

    loadData = () => {
        const {record: { evaluateCode }} = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryClinicalQuotationVersionList,
            data: { evaluateCode },
            dataType: 'json',
            doneResult: res => {
                const { datas = {} } = res;
                const { tabs } = this.state;
                for (let key in datas){
                    tabs.push({
                        key,
                        tab: clinicalQuotationTypeShow[key],
                    });
                };
                const { key } = tabs[0] || {};
                this.setState({
                    data: datas,
                    tabs,
                    activeKey: key,
                    loading: false,
                })
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '发布时间',
        dataIndex: 'publishedDate',
        key: 'publishedDate',
        width: 100,
    }, {
        title: '发布人',
        dataIndex: 'publishUserName',
        key: 'publishUserName',
        width: 100,
    }, {
        title: '发布前总价（含税金额）',
        dataIndex: 'beforePublishAmount',
        key: 'beforePublishAmount',
        width: 120,
    }, {
        title: '发布后总价（含税金额）',
        dataIndex: 'afterPublishAmount',
        key: 'afterPublishAmount',
        width: 120,
    }, {
        title: '版本号',
        dataIndex: 'versionNum',
        key: 'versionNum',
        width: 120,
    }, {
        title: '操作',
        dataIndex: 'operate',
        key: 'operate',
        width: 120,
        render: (text, record) => {
            // const { clinicalQuotationRecordList = [] } = record;
            // const haveVisitQuote = clinicalQuotationRecordList.find(el => el.clinicalQuotationTypeShow == '访视报价');
            // const haveFTEQuote = clinicalQuotationRecordList.find(el => el.clinicalQuotationTypeShow == 'FTE报价');
            const { activeKey } = this.state;
            return <div>
                {/* {
                    haveVisitQuote && <a onClick={() => this.visitQuote(clinicalQuotationRecordList)}>访视报价</a>
                }
                {
                    (haveVisitQuote && haveFTEQuote) && <span className="ant-divider" />
                }
                { 
                    haveFTEQuote && <a onClick={this.FTEQuote}>FTE报价</a>
                } */}
                {activeKey === 'CLINICAL_QUOTATION_TYPE_VISIT' && <a onClick={() => this.export(record.clinicalQuotationRecordId)}>访视报价</a>}
                {activeKey === 'CLINICAL_QUOTATION_TYPE_FTE' && <a onClick={() => this.export(record.clinicalQuotationRecordId)}>FTE报价</a>}
            </div>
        }
    }]

    export = (clinicalQuotationRecordId) => {
        if (!clinicalQuotationRecordId) {
            return
        }
        const options = {
            method: "POST",
            url: API_URL.evaluate.exportClinicalQuotationRecord,
            data: {
                clinicalQuotationRecordId,
            },
            dataType: "json",
            doneResult: (res) => {
                message.success(res.success)
            },
        };
        $.sendRequest(options);
    };

    handleTabClick = (key) => {
        this.setState({
            activeKey: key,
        })
    }

    render() {
        const { visible, loading, data, record, tabs, activeKey } = this.state;
        const { evaluateCode } = record;
        return (
            <Modal
                title="报价版本记录"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width="1000px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div style={{ marginBottom: 16 }}>
                        临床评估单号：{evaluateCode}
                    </div>
                    <div>
                        {
                            !!tabs.length && <Tabs type="card" activeKey={activeKey} onChange={this.handleTabClick}>
                                {tabs.map(pane => <TabPane tab={pane.tab} key={pane.key}></TabPane>)}
                            </Tabs>
                        }
                        <Table
                            rowKey={record => record.clinicalQuotationId}
                            dataSource={data[activeKey]}
                            loading={loading}
                            columns={this.getColumns()}
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default QuoteVersionRecord;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/QuoteVersionRecord.js